import { render, staticRenderFns } from "./selector_articulos_imagen.vue?vue&type=template&id=beaffe5e&"
import script from "./selector_articulos_imagen.vue?vue&type=script&lang=js&"
export * from "./selector_articulos_imagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports